import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ReceiptDialogData {
  key: string;
  value: string;
}

@Component({
  selector: 'app-recipt-dialog',
  templateUrl: './recipt-dialog.component.html',
  styleUrl: './recipt-dialog.component.scss',
})
export class ReciptDialogComponent {
  @Input() visible: boolean = false;
  @Input() data: ReceiptDialogData[] = [];
  @Input() logoUrl: string = 'assets/images/app_logo.png';
  @Input() subText: string = 'NCC Bank Limited';
  @Input() headerTitle: string = 'Thank You';
  @Input() headerSubtitle: string = 'Transaction is Successful';
  @Input() headerType: 'success' | 'error' = 'success';
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onDownload = new EventEmitter<void>();

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  download() {
    this.onDownload.emit();
  }
}
